



























import {Component, Inject, Prop} from "vue-property-decorator";
import CommonBase from "@/components/CommonBase";
import Api from "@/components/prelogin/Api";
import {PendingEmailConfirmInfo} from "@/modules/models";
import rd from "@/modules/vRoutedefs";
import BaseApi from "@/store/modules/base";

@Component
export default class EmailConfirmPage extends CommonBase {
    @Inject()
    api!: Api;
    @Inject()
    baseApi!: BaseApi;

    @Prop()
    secret!: string;

    working = false;
    errMsg: string | null = null;
    notfound = false;

    info: PendingEmailConfirmInfo | null = null;

    get email() {
        return this.info?.email;
    }
    get name() {
        return this.info?.name;
    }

    get meRoutePath() {
        return rd.start.me.path;
    }
    get loginRoutePath() {
        return rd.login.path;
    }

    async load() {
        this.working = true;
        try {
            const resp = await this.api.fetchPendingEmailConfirmInfo(this.secret);
            if(resp instanceof PendingEmailConfirmInfo) {
                this.info = resp;
            } else if(resp.num == 203) { // Wrong secret
                this.notfound = true;
            } else {
                this.errMsg = `${resp.msg} (${resp.num}`;
            }
        } finally {
            this.working = false;
        }
    }

    async confirm() {
        this.working = true;
        try {
            const confirmed = await this.api.confirmPendingPersonEmail(this.secret);
            if(confirmed) {
                this.emitSnack(`Epost adresse bekreftet`);
                if(this.baseApi.authenticated) {
                    await this.baseApi.loadUser();
                    await this.$router.replace(this.meRoutePath);
                } else {
                    await this.$router.replace(this.loginRoutePath);
                }
            } else {
                this.notfound = true;
            }
        } finally {
            this.working = false;
        }
    }

    created() {
        this.load();
    }
}
